import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import React from "react";
import CycleReportTable from "../../../../components/material/DeviceDashboard/CycleReport/CycleReportTable";
import { useTranslation } from "react-i18next";
import ReportTypeToggle from "../../../../components/material/DeviceDashboard/CycleReport/ReportTypeToggle";
import SubCard from "src/components/material/Cards/SubCard";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedCycle, fetchCycleEvents, fetchDeviceCycles, setComplianceReport } from "../deviceDashboardSlice";

const CycleReportContainer = () => {
    const { t } = useTranslation("translations");
    const {
        deviceCycles,
        deviceFacilityAddress,
        customerName,
        deviceSerial,
        weightUnit,
        selectedCycle,
        biochallengeInfo,
        currentPressureUnit,
        complianceReport,
        deviceTimezone,
        userTimezone,
        fromDate,
        toDate,
        deviceConfigId,
    } = useSelector(
        // @ts-ignore
        (store) => store.devicedashboard
    );

    const loading = useSelector((store) => store.devicedashboard.loading.cycleReport);

    const dispatch = useDispatch();

    const cycleSelectionHandler = (cycle) => {
        dispatch(setSelectedCycle(cycle.row));
        // @ts-ignore
        dispatch(fetchCycleEvents(cycle.id));
    };

    const fetchCycles = () => {
        // @ts-ignore
        dispatch(fetchDeviceCycles());
    };

    const setReportType = (/** @type {boolean} */ isCompliance) => {
        // @ts-ignore
        dispatch(setComplianceReport(isCompliance));
    };

    return (
        <SubCard
            sx={{ width: "100%" }}
            title={t("Cycle Report")}
            titleProps={{ color: "primary", fontWeight: "bold" }}
            titleVariant={"h4"}
            secondary={<ReportTypeToggle deviceConfigId={deviceConfigId} setComplianceReport={setReportType} fetchCycles={fetchCycles} />}>
            <CardContent sx={{ padding: 0 }}>
                <CycleReportTable
                    deviceCycles={deviceCycles}
                    deviceFacilityAddress={deviceFacilityAddress}
                    customerName={customerName}
                    deviceSerial={deviceSerial}
                    weightUnit={weightUnit}
                    selectedCycle={selectedCycle}
                    biochallengeInfo={biochallengeInfo}
                    currentPressureUnit={currentPressureUnit}
                    complianceReport={complianceReport}
                    deviceTimezone={deviceTimezone}
                    userTimezone={userTimezone}
                    fromDate={fromDate}
                    toDate={toDate}
                    loading={loading}
                    isSummary={false}
                    cycleSelectionHandler={cycleSelectionHandler}
                />
            </CardContent>
        </SubCard>
    );
};

export default CycleReportContainer;
